import React from 'react';
import { is1024andSmaller } from 'swag-client-common/utils/ui.utils';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import Drawer from '../../ui/drawer';
import { ANIMATION_TRANSITION_TIME, STEPS } from '../../../redux/box-builder/box-builder.constants';
import { moveDownIntercom, moveUpIntercom, moveUpIntercomMobile } from '../../../utils/ui.utils';
import SelectCardProductsContent from './components/select-card-products-content';
import SelectCardAddonsContent from './components/select-card-addons-content';
import { SelectCartItemsHeader } from './components/select-cart-items-header';
import SelectCartAddonItemsHeader from './select-cart-addon-items-header';
import classes from './box-builder-select-products-drawer.scss';
import animationClasses from './anim.scss';
const STEP_TO_HEADER = {
  [STEPS.SELECT_ADDONS_FOR_BOX]: /*#__PURE__*/React.createElement(SelectCartAddonItemsHeader, null),
  [STEPS.SELECT_PRODUCTS_FOR_BOX]: /*#__PURE__*/React.createElement(SelectCartItemsHeader, null)
};
const STEP_TO_CONTENT = {
  [STEPS.SELECT_ADDONS_FOR_BOX]: /*#__PURE__*/React.createElement(SelectCardAddonsContent, {
    isAddonFlow: true
  }),
  [STEPS.SELECT_PRODUCTS_FOR_BOX]: /*#__PURE__*/React.createElement(SelectCardProductsContent, {
    isAddonFlow: false
  })
};
export default function BoxBuilderSelectProductsDrawer({
  open,
  onClose,
  currentStep,
  hasUnsavedChanges
}) {
  React.useEffect(() => {
    if (open) {
      if (is1024andSmaller()) {
        moveUpIntercomMobile();
      } else {
        moveUpIntercom();
      }
    } else {
      moveDownIntercom();
    }
  }, [open]);
  const isAddonFlow = currentStep === STEPS.SELECT_ADDONS_FOR_BOX;
  const header = /*#__PURE__*/React.createElement(SwitchTransition, null, /*#__PURE__*/React.createElement(CSSTransition, {
    classNames: animationClasses,
    key: currentStep,
    timeout: ANIMATION_TRANSITION_TIME
  }, STEP_TO_HEADER[currentStep] || /*#__PURE__*/React.createElement("div", null)));
  const content = /*#__PURE__*/React.createElement(SwitchTransition, null, /*#__PURE__*/React.createElement(CSSTransition, {
    classNames: animationClasses,
    key: currentStep,
    timeout: ANIMATION_TRANSITION_TIME
  }, STEP_TO_CONTENT[currentStep] || /*#__PURE__*/React.createElement("div", null)));
  return /*#__PURE__*/React.createElement(Drawer, {
    overlayZIndex: 1400,
    open: open,
    headerClassName: isAddonFlow ? classes.addonHeader : classes.header,
    onClose: () => onClose(hasUnsavedChanges),
    anchor: "bottom",
    transitionTime: ANIMATION_TRANSITION_TIME,
    paperClassName: classes.paper,
    isButtonDisabled: true,
    dataDrawer: "BoxBuilderSelectProductsDrawer",
    isLoading: false,
    isButtonShown: false,
    closeClassName: classes.close,
    MiddleBlock: header
  }, content);
}